"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.ThemeVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
var ThemeVariants;
(function (ThemeVariants) {
    ThemeVariants["Light"] = "light";
    ThemeVariants["Dark"] = "dark";
})(ThemeVariants || (exports.ThemeVariants = ThemeVariants = {}));
const ThemeContext = (0, react_1.createContext)(null);
const useTheme = () => {
    const theme = (0, react_1.useContext)(ThemeContext);
    return theme;
};
exports.useTheme = useTheme;
const Theme = ({ onThemeChange, getInitialTheme, children, }) => {
    const [currentTheme, setCurrentTheme] = (0, react_1.useState)(ThemeVariants.Light);
    const handleThemeToggle = (0, react_1.useCallback)(() => {
        const newTheme = currentTheme === ThemeVariants.Light
            ? ThemeVariants.Dark
            : ThemeVariants.Light;
        setCurrentTheme(newTheme);
        onThemeChange(newTheme);
    }, [currentTheme, document]);
    (0, react_1.useEffect)(() => {
        const themeId = getInitialTheme();
        if (themeId) {
            setCurrentTheme(themeId);
            onThemeChange(themeId);
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(ThemeContext.Provider, { value: { onThemeToggle: handleThemeToggle, currentTheme }, children: children }));
};
exports.default = Theme;
